/**
 * Copyright (c) SAGE3 Development Team 2022. All Rights Reserved
 * University of Hawaii, University of Illinois Chicago, Virginia Tech
 *
 * Distributed under the terms of the SAGE3 License.  The full license is in
 * the file LICENSE, distributed as part of this software.
 */

import { z } from 'zod';

/**
 * SAGE3 application: PluginApp
 * created by: Ryan
 */

export const schema = z.any();

export type state = z.infer<typeof schema>;

export const init: Partial<state> = {
  pluginName: '',
};

export const name = 'PluginApp';
